export default __webpack_public_path__ + "static/media/certificate_4.ca271080.jpg";